const teamElement = document.querySelector('.Team')

if (teamElement) {
  const teamDialog = document.querySelector('.Team-dialog')
  const teamDialogTitle = teamDialog.querySelector('#team-dialog-title')
  const teamDialogPosition = teamDialog.querySelector('#team-dialog-position')
  const teamDialogContent = teamDialog.querySelector('#team-dialog-content')
  const teamDialogImage = teamDialog.querySelector('#team-dialog-image')
  const teamButtons = document.querySelectorAll('.Team-memberButton')
  const teamDialogCloseButton = document.querySelector('.Team-dialogClose')

  teamDialogCloseButton.addEventListener('click', () => {
    teamDialog.close()
  })

  Array.prototype.forEach.call(teamButtons, function (teamButton) {
    teamButton.addEventListener('click', () => {
      const memberId = teamButton.getAttribute('data-member')
      const member = document.jsVariables.teamData[memberId]

      const preload = new Image()
      preload.src = member.image

      teamDialog.classList.add('--loading')
      teamDialog.scrollTop = 0

      teamDialogTitle.textContent = member.title
      teamDialogImage.setAttribute('alt', member.alt)
      teamDialogImage.setAttribute('style', member.style)
      teamDialogPosition.textContent = member.position
      teamDialogContent.innerHTML = member.details

      teamDialog.showModal()

      preload.onload = () => {
        teamDialog.classList.remove('--loading')
        teamDialogImage.src = member.image
      }
    })
  })
}
